( function () {
	'use strict';

	var filterSelector = '.wp-block-woocommerce-product-filter-taxonomy';
	var itemSelector = '.wc-block-product-filter-checkbox-list__item';

	/**
	 * Adds a stable depth value to every product-category filter item.
	 *
	 * WooCommerce serializes data-wp-context on server-rendered items, but the
	 * items inserted by the "show more" interaction only inherit that context
	 * internally. Reading the complete item list from the filter root keeps the
	 * visual hierarchy intact for both rendering paths.
	 *
	 * @param {Element} filter Product taxonomy filter block.
	 * @return {void}
	 */
	function applyDepths( filter ) {
		var context;
		var depths = Object.create( null );

		try {
			context = JSON.parse( filter.getAttribute( 'data-wp-context' ) || '{}' );
		} catch ( error ) {
			return;
		}

		if ( ! Array.isArray( context.items ) ) {
			return;
		}

		context.items.forEach( function ( item ) {
			if ( 'string' === typeof item.id ) {
				depths[ item.id ] = Number.isSafeInteger( item.depth ) && item.depth > 0 ? item.depth : 0;
			}
		} );

		filter.querySelectorAll( itemSelector ).forEach( function ( element ) {
			var input = element.querySelector( 'input[id]' );
			var depth = input && Object.prototype.hasOwnProperty.call( depths, input.id ) ? depths[ input.id ] : 0;

			element.style.setProperty( '--folis-product-category-depth', String( depth ) );
		} );
	}

	function initialize( filter ) {
		if ( filter.dataset.folisCategoryDepthReady ) {
			return;
		}

		filter.dataset.folisCategoryDepthReady = 'true';
		applyDepths( filter );

		new MutationObserver( function () {
			applyDepths( filter );
		} ).observe( filter, { childList: true, subtree: true } );
	}

	function initializeAll() {
		document.querySelectorAll( filterSelector ).forEach( initialize );
	}

	initializeAll();

	// Filters update in place (Interactivity API router), which can replace
	// the filter blocks after this script has run.
	var queued = false;
	new MutationObserver( function () {
		if ( queued ) {
			return;
		}
		queued = true;
		window.requestAnimationFrame( function () {
			queued = false;
			initializeAll();
		} );
	} ).observe( document.body, { childList: true, subtree: true } );
}() );
